import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class ResultsSprintRoute extends Route 
{
	@service store;
	
	model(params) 
	{
		return hash(
		{
			event: this.modelFor('event'),
			events: this.store.findAll('Event'),
		});
	}
}